"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.routesToPath = exports.routesToLineString = exports.roundDownPosition = exports.insertIntoArray = exports.breakMeridianPaths = exports.getNearestNeighbour = exports.processMeridianCrossing = exports.setOptions = exports.getLocationHash = exports.alterFeatureCoordinates = void 0;
var helpers_1 = require("@turf/helpers");
var distance_1 = __importDefault(require("@turf/distance"));
/**
 * This function cycles through the coordinates and checks if it should be correct into a full positive or negative 360 degree cycle
 */
var alterFeatureCoordinates = function (originalFeatureCollection, direction) {
    if (direction === void 0) { direction = "LTR"; }
    var features = [];
    originalFeatureCollection.features.forEach(function (feature) {
        if (!feature.geometry)
            return;
        features.push(__assign(__assign({}, feature), { geometry: __assign(__assign({}, feature.geometry), { coordinates: feature.geometry.coordinates.map(function (coord) {
                    if (direction === "LTR") {
                        if (coord[0] <= 0) {
                            return [coord[0] + 360, coord[1]];
                        }
                        return coord;
                    }
                    else if (direction === "RTL") {
                        if (coord[0] >= 0) {
                            return [coord[0] - 360, coord[1]];
                        }
                        return coord;
                    }
                    else {
                        console.error("THIS SHOULDN'T HAPPEN!");
                        return coord;
                    }
                }) }) }));
    });
    return __assign(__assign({}, originalFeatureCollection), { features: features });
};
exports.alterFeatureCoordinates = alterFeatureCoordinates;
var getLocationHash = function (coordinate) { return coordinate.join(","); };
exports.getLocationHash = getLocationHash;
var setOptions = function (nonIRTC, useSuez, usePanama) {
    if (nonIRTC === void 0) { nonIRTC = false; }
    if (useSuez === void 0) { useSuez = true; }
    if (usePanama === void 0) { usePanama = true; }
    return ({
        distance: function (fromNode, toNode, link) {
            var _a, _b, _c;
            if (!nonIRTC) {
                if (((_a = link.data) === null || _a === void 0 ? void 0 : _a.desc_) === "nonirtc") {
                    return Number.MAX_SAFE_INTEGER;
                }
            }
            if (!useSuez) {
                if (((_b = link.data) === null || _b === void 0 ? void 0 : _b.desc_) === "suez") {
                    return Number.MAX_SAFE_INTEGER;
                }
            }
            if (!usePanama) {
                if (((_c = link.data) === null || _c === void 0 ? void 0 : _c.desc_) === "panama") {
                    return Number.MAX_SAFE_INTEGER;
                }
            }
            return (0, distance_1.default)((0, helpers_1.point)([fromNode.data.x, fromNode.data.y]), (0, helpers_1.point)([toNode.data.x, toNode.data.y]));
        },
        heuristic: function (fromNode, toNode) {
            return (0, distance_1.default)((0, helpers_1.point)([fromNode.data.x, fromNode.data.y]), (0, helpers_1.point)([toNode.data.x, toNode.data.y]));
        },
    });
};
exports.setOptions = setOptions;
function roundDownPosition(coor, decimalLength) {
    if (decimalLength === void 0) { decimalLength = 3; }
    return [
        Number(coor[0].toFixed(decimalLength)),
        Number(coor[1].toFixed(decimalLength)),
    ];
}
exports.roundDownPosition = roundDownPosition;
/**
 * This checks the starting and finishing coordinates then indicates if it has been changed
 * and the direction of change
 * @param {Position} start
 * @param {Position} finish
 * @returns {coord: [Position, Position], changed: boolean, direction?: CycleDirection}
 */
var processMeridianCrossing = function (start, finish) {
    var coord = [start, finish];
    var changed = false;
    var direction;
    /**
     * In the situations where the longitude of the start and finish coordinates
     * are in the same side direction, we don't need to modify the coordinates
     * i.e. (start[0] >= 0 && finish[0] >= 0) and (start[0] <= 0 && finish[0] <= 0)
     */
    if (start[0] >= 0 && finish[0] <= 0) {
        changed = true;
        coord = [start, [finish[0] + 360, finish[1]]];
        direction = "LTR";
    }
    else if (start[0] <= 0 && finish[0] >= 0) {
        changed = true;
        coord = [start, [finish[0] - 360, finish[1]]];
        direction = "RTL";
    }
    return {
        coord: [roundDownPosition(coord[0]), roundDownPosition(coord[1])],
        changed: changed,
        direction: direction,
    };
};
exports.processMeridianCrossing = processMeridianCrossing;
var getNearestNeighbour = function (coord, vertices) {
    var nearestNeighbour = vertices.reduce(function (acc, vertex) {
        var calcDistance = (0, distance_1.default)((0, helpers_1.point)(vertex), (0, helpers_1.point)(coord));
        if (acc.selected === undefined) {
            return { selected: vertex, distance: calcDistance };
        }
        else {
            if (acc.distance >= calcDistance) {
                return { selected: vertex, distance: calcDistance };
            }
            return acc;
        }
    }, {
        selected: undefined,
        distance: 0,
    });
    return nearestNeighbour.selected;
};
exports.getNearestNeighbour = getNearestNeighbour;
var isNegativeOrPositive = function (value) {
    return value < 0 ? "negative" : "positive";
};
var checkIfPathHasCoordinatesCrossingMeridian = function (paths) {
    // This is to check if there are any coordinates near the meridian
    var isWithinRange = paths.filter(function (o) { return o[0] >= 180 || o[0] <= -180; });
    if (!isWithinRange.length)
        return false;
    var starting = isNegativeOrPositive(paths[0][0]);
    var hasChanged = paths.reduce(function (acc, position, index) {
        if (!index || acc === "changed")
            return acc;
        if (isNegativeOrPositive(position[0]) !== acc) {
            return "changed";
        }
        return acc;
    }, starting);
    return hasChanged === "changed";
};
function adjustLng(value) {
    var adjusted;
    if (value >= 180) {
        adjusted = value - 360;
    }
    else if (value <= -180) {
        adjusted = value + 360;
    }
    else {
        // -179 < x < 179
        adjusted = value;
    }
    return Number(adjusted.toFixed(3));
}
var breakMeridianPaths = function (paths, direction) {
    // If the path doesn't make use of modified graphs or doesn't have any +ve/-ve change within the path, skip!
    if (!direction && !checkIfPathHasCoordinatesCrossingMeridian(paths))
        return [paths];
    var breakPoints = [];
    var reformattedPositions = paths.reduce(function (acc, node, index) {
        var newLongitude = adjustLng(node[0]);
        if (!index) {
            acc.push([newLongitude, node[1]]);
        }
        else {
            var prevLngState = isNegativeOrPositive(acc[acc.length - 1][0]);
            var correctedLngState = isNegativeOrPositive(newLongitude);
            if (prevLngState !== correctedLngState) {
                if (Math.abs(newLongitude) !== 180 && Math.abs(newLongitude) > 90) {
                    var prevNode = acc[acc.length - 1];
                    if (Math.abs(prevNode[0]) === 180) {
                        breakPoints.push(acc.length);
                        acc.push(isNegativeOrPositive(newLongitude) === "negative"
                            ? [-180, prevNode[1]]
                            : [180, prevNode[1]]);
                    }
                    else {
                        if (Math.abs(newLongitude) !== 180) {
                            acc.push(isNegativeOrPositive(newLongitude) !== "negative"
                                ? [-180, node[1]]
                                : [180, node[1]]);
                            breakPoints.push(acc.length);
                            acc.push(isNegativeOrPositive(newLongitude) === "negative"
                                ? [-180, node[1]]
                                : [180, node[1]]);
                        }
                        else {
                            breakPoints.push(acc.length + 1);
                        }
                        acc.push([newLongitude, node[1]]);
                    }
                }
                else {
                    var prevLongitude = acc[acc.length - 1][0];
                    if (Math.abs(newLongitude) > 90 && Math.abs(prevLongitude) > 90) {
                        if (Math.abs(prevLongitude) !== 180) {
                            acc.push(isNegativeOrPositive(prevLongitude) === "negative"
                                ? [-180, node[1]]
                                : [180, node[1]]);
                        }
                        breakPoints.push(acc.length);
                    }
                    acc.push([newLongitude, node[1]]);
                }
            }
            else {
                acc.push([newLongitude, node[1]]);
            }
        }
        return acc;
    }, []);
    var finalPath = [];
    // Where breakpoints have been identified, split the array - particularly at 180 degree meridian
    if (breakPoints.length) {
        do {
            var check = reformattedPositions.splice(0, breakPoints.shift());
            finalPath.push(check);
        } while (breakPoints.length);
        finalPath.push(reformattedPositions);
    }
    else {
        finalPath.push(reformattedPositions);
    }
    return finalPath;
};
exports.breakMeridianPaths = breakMeridianPaths;
var insertIntoArray = function (array, item, index) {
    if (index === void 0) { index = 0; }
    return __spreadArray(__spreadArray(__spreadArray([], array.slice(0, index), true), [item], false), array.slice(index), true);
};
exports.insertIntoArray = insertIntoArray;
function routesToLineString(routes) {
    return routes.reduce(function (acc, route) {
        var interim = route.path.reduce(function (acc2, path) {
            acc2 = acc2.concat(path);
            return acc2;
        }, []);
        acc = acc.concat(interim);
        return acc;
    }, []);
}
exports.routesToLineString = routesToLineString;
function routesToPath(routes) {
    return routes.reduce(function (acc, route) {
        acc = acc.concat(route.path);
        return acc;
    }, []);
}
exports.routesToPath = routesToPath;
